import { useNavigate, useLocation } from 'react-router-dom';
import { ClipboardList, Banknote, UserSquare2 } from 'lucide-react';

/**
 * Shared sub-tab bar for the three "Loan Portfolio" pages.
 *
 * They all show overlapping data (cases / loans / customers), so the
 * sidebar collapses to a single entry and this component lets users
 * flip between views in-place instead of round-tripping to the sidebar.
 *
 * Drop this directly under each page's header.
 */
const TABS = [
  { path: '/owner/recovery/cases',     label: 'Cases',     icon: ClipboardList, hint: 'Worklist' },
  { path: '/owner/recovery/loans',     label: 'Loans',     icon: Banknote,      hint: 'Full portfolio' },
  { path: '/owner/recovery/customers', label: 'Customers', icon: UserSquare2,   hint: 'Borrowers' },
];

export function PortfolioTabs() {
  const navigate = useNavigate();
  const loc = useLocation();

  return (
    <div
      className="panel"
      style={{
        padding: '6px',
        marginBottom: '12px',
        display: 'inline-flex',
        gap: '4px',
        flexWrap: 'wrap',
      }}
    >
      {TABS.map((t) => {
        const active = loc.pathname === t.path || loc.pathname.startsWith(`${t.path}/`);
        const Icon = t.icon;
        return (
          <button
            key={t.path}
            type="button"
            onClick={() => navigate(t.path)}
            data-testid={`portfolio-tab-${t.label.toLowerCase()}`}
            style={{
              padding: '6px 14px',
              fontSize: '13px',
              fontWeight: 600,
              borderRadius: '6px',
              border: 'none',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              background: active ? 'var(--navy, #1e3a8a)' : 'transparent',
              color: active ? '#fff' : 'var(--g3)',
              transition: 'all 0.15s ease',
            }}
            title={t.hint}
          >
            <Icon size={13} />
            <span>{t.label}</span>
          </button>
        );
      })}
    </div>
  );
}
